module.exports = __webpack_public_path__ + "static/media/air-bg.c99c58b8.jpg";